/* eslint-disable */
import React, { Component } from 'react';
import { Contact00DataSource,Contact01DataSource,Contact02DataSource } from './data.source';
import Contact0 from './Contact0';
import { enquireScreen } from 'enquire-js';
import './less/antMotionStyle.less';
require("./less/viewStyle.css")

let isMobile;
enquireScreen((b) => {
    isMobile = b;
});

const { location } = window;


export default class contactView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isMobile,
            show: !location.port, // 如果不是 dva 2.0 请删除
        };
    }

    componentWillMount() {

    }
    componentDidMount() {
        // 适配手机屏幕;
        enquireScreen((b) => {
            this.setState({ isMobile: !!b });
        });
        // dva 2.0 样式在组件渲染之后动态加载，导致滚动组件不生效；线上不影响；
        /* 如果不是 dva 2.0 请删除 start */
        if (location.port) {
            // 样式 build 时间在 200-300ms 之间;
            setTimeout(() => {
                this.setState({
                    show: true,
                });
            }, 500);
        }
        /* 如果不是 dva 2.0 请删除 end */
    }

    componentWillReceiveProps(nextProps) {

    }

    render() {
        return (
            <div className="view">
                <div className="view-top">
                    <div className="view-left" >
                        <h3 className="view-title">雨后地软(总部)</h3>
                        <img src="/img/nsec.png" className="logoImg" />
                        <p>地址:南京市鼓楼区中山北路550号</p>
                        <p>电话:025-89670505</p>
                        <p>邮箱:yhdr@njyhdr.com</p>
                        <p>邮编:210003</p>
                    </div>
                    <div className="view-right">
                        <Contact0
                            id="Contact0_0"
                            key="Contact0_0"
                            dataSource={Contact00DataSource}
                            isMobile={this.state.isMobile}
                        />
                    </div>
                </div>

                <div className="view-center">
                    <div className="view-left" >
                        <h3 className="view-title">江苏及象生态环境研究院</h3>
                        <img src="/img/nsec.png" className="logoImg" />
                        <p>地址:南京市鼓楼区古平岗4号智梦园C座4楼</p>
                        <p>电话:025-89670101</p>
                        <p>邮箱:790216972@qq.com</p>
                        <p>邮编:210012</p>
                    </div>
                    <div className="view-right" >
                        <Contact0
                            id="Contact0_0"
                            key="Contact0_0"
                            dataSource={Contact01DataSource}
                            isMobile={this.state.isMobile}
                        />
                    </div>
                </div>

                <div className="view-bottom">
                    <div className="view-left">

                        <h3 className="view-title">青海分公司</h3>
                        <img src="./img/nsec.png" className="logoImg" />
                        <p>地址:西宁市城东区共和路56号</p>
                        <p>邮箱:yhdr@njyhdr.com</p>
                        <p>邮编:810007</p>

                    </div>
                    <div className="view-right">
                        <Contact0
                            id="Contact0_0"
                            key="Contact0_0"
                            dataSource={Contact02DataSource}
                            isMobile={this.state.isMobile}
                        />
                    </div>
                </div>
            </div>
        )
    }
}

